import { useTranslation } from '@kostbar/i18n'
import { getBuildInfo } from '@kostbar/monitoring'
import { UserInfo } from '../components/user-info'
import { RoleBadges } from '../components/role-badges'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export function ProfilePage() {
  const { t: tProfile } = useTranslation('profile')
  // Compile-time constants, so this is a plain read rather than state (ADR-029).
  // The backoffice bundle ships inside the cloud-service image, so this is also the version of the
  // backend serving it.
  const build = getBuildInfo()

  return (
    <div className="max-w-2xl">
      <h1 className="text-3xl font-bold mb-6">{tProfile('title')}</h1>

      <Card>
        <CardHeader>
          <CardTitle>{tProfile('infoTitle')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <UserInfo />
          <RoleBadges />
        </CardContent>
      </Card>

      <Card className="mt-6">
        <CardHeader>
          <CardTitle>{tProfile('buildTitle')}</CardTitle>
        </CardHeader>
        <CardContent>
          <dl className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <dt className="text-muted-foreground">
                {tProfile('buildVersion')}
              </dt>
              <dd className="font-medium">{build.version}</dd>
            </div>
            {build.commit && (
              <div>
                <dt className="text-muted-foreground">
                  {tProfile('buildCommit')}
                </dt>
                <dd className="font-medium font-mono">{build.commit}</dd>
              </div>
            )}
            {build.buildTime && (
              <div className="col-span-2">
                <dt className="text-muted-foreground">
                  {tProfile('buildTime')}
                </dt>
                <dd className="font-medium">
                  {new Date(build.buildTime).toLocaleString('de-AT')}
                </dd>
              </div>
            )}
          </dl>
        </CardContent>
      </Card>
    </div>
  )
}
